/* eslint-disable max-classes-per-file */
/* global axios */
import ApiClient from './ApiClient';

class OrgUnitsAPI extends ApiClient {
  constructor() {
    super('org_units', { accountScoped: true });
  }

  assignMembers({ id, members }) {
    return axios.post(`${this.url}/${id}/assign_members`, { members });
  }

  attachInboxes({ id, inboxIds }) {
    return axios.post(`${this.url}/${id}/attach_inboxes`, {
      inbox_ids: inboxIds,
    });
  }
}

class AccessRolesAPI extends ApiClient {
  constructor() {
    super('access_roles', { accountScoped: true });
  }

  catalogue() {
    return axios.get(`${this.url}/permissions_catalogue`);
  }

  updateMode(mode) {
    return axios.post(`${this.url}/settings`, { mode });
  }
}

class UserImportsAPI extends ApiClient {
  constructor() {
    super('user_imports', { accountScoped: true });
  }

  upload(file, dryRun) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('dry_run', dryRun ? 'true' : 'false');
    return axios.post(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export const OrgUnitsApi = new OrgUnitsAPI();
export const AccessRolesApi = new AccessRolesAPI();
export const UserImportsApi = new UserImportsAPI();
